import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProgressBar = styled.div`
  display: flex;
  gap: 2px;
`;

const Step = styled.div`
  flex: 1;
  height: 4px;
  background: ${({ theme, highlight }) =>
    highlight
      ? theme.colors.palette.black
      : theme.colors.embroideryProgressBarBackground};
`;

export const EmbroideryProgressBar = ({ numPages, currentIdx }) => {
  const steps = [...Array(numPages)].map((_, idx) => (
    <Step key={idx} highlight={currentIdx === idx} />
  ));

  return <ProgressBar>{steps}</ProgressBar>;
};

EmbroideryProgressBar.propTypes = {
  currentIdx: PropTypes.number,
  numPages: PropTypes.number,
};
